// extracted by mini-css-extract-plugin
export default {"loginContainer":"login_loginContainer__zDEP0","logo":"login_logo__PqVrD","logo-name":"login_logo-name__S0wln","kakaoBtn":"login_kakaoBtn__zqna5","googleBtn":"login_googleBtn__pL6Ge"};